var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input-field',_vm._b({attrs:{"type":"email","label":_vm.label || _vm.$t('authenticationUserIdLabel')},on:{"input":function($event){return _vm.$emit('input', $event)}},scopedSlots:_vm._u([{key:"accessory",fn:function(){return [_vm._t("accessory")]},proxy:true}],null,true)},'input-field',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }